(() => {
  if (window.mhB2BMotion) return;
  window.mhB2BMotion = true;
  const controllers = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = matchMedia('(min-width: 901px) and (hover: hover) and (pointer: fine)');
  const easing = 'cubic-bezier(.2,.75,.25,1)';
  function setup(root) {
    if (controllers.has(root) || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
    const hero = root.querySelector('.mh-b2b-hero');
    const image = hero?.querySelector('img');
    const animations = new Set();
    let observer, frame = 0, heroVisible = false;
    const animate = (element, frames, options = {}) => {
      if (reduced.matches || element.contains(document.activeElement)) return;
      const animation = element.animate(frames, {duration: 620, easing, ...options});
      animations.add(animation);
      animation.onfinish = animation.oncancel = () => animations.delete(animation);
    };
    const paint = () => {
      frame = 0;
      if (!root.isConnected || !heroVisible || !desktop.matches || reduced.matches || !image) return;
      const rect = hero.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, (innerHeight - rect.top) / (innerHeight + rect.height)));
      image.style.setProperty('--mh-b2b-image-y', `${(progress - .5) * 24}px`);
    };
    const schedule = () => {if (!frame && heroVisible && desktop.matches && !reduced.matches) frame = requestAnimationFrame(paint)};
    const stop = () => {
      observer?.disconnect();
      animations.forEach(animation => animation.cancel());
      animations.clear();
      cancelAnimationFrame(frame); frame = 0;
      image?.style.removeProperty('--mh-b2b-image-y');
      root.removeAttribute('data-motion');
    };
    const start = () => {
      stop();
      if (reduced.matches) return;
      root.dataset.motion = 'on';
      const targets = root.querySelectorAll('.mh-editorial-heading > *, .mh-b2b-hero, .mh-business-intro > *, .mh-business-grid > a, .mh-business-contact > *');
      const revealed = new WeakSet();
      observer = new IntersectionObserver(entries => {
        let stagger = 0;
        entries.forEach(entry => {
          if (entry.target === hero) {heroVisible = entry.isIntersecting; schedule()}
          if (!entry.isIntersecting || revealed.has(entry.target)) return;
          revealed.add(entry.target);
          // Never leave text or controls hidden while waiting to enter the viewport.
          if (entry.target === hero) animate(hero, [
            {clipPath: 'inset(5% 2% 0 round 30px)'},
            {clipPath: 'inset(0% 0% 0 round 30px)'}
          ], {duration: 850});
          else animate(entry.target, [
            {opacity: 0, transform: 'translate3d(0,20px,0)'},
            {opacity: 1, transform: 'translate3d(0,0,0)'}
          ], {delay: Math.min(stagger++ * 55, 165), fill: 'backwards'});
          if (entry.target !== hero) observer.unobserve(entry.target);
        });
      }, {threshold: .12});
      targets.forEach(element => observer.observe(element));
    };
    const focus = event => animations.forEach(animation => {
      if (animation.effect?.target?.contains(event.target)) animation.cancel();
    });
    const resize = () => {if (!desktop.matches) image?.style.removeProperty('--mh-b2b-image-y'); schedule()};
    root.addEventListener('focusin', focus);
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', resize, {passive: true});
    reduced.addEventListener('change', start);
    start();
    controllers.set(root, () => {
      stop(); root.removeEventListener('focusin', focus);
      window.removeEventListener('scroll', schedule); window.removeEventListener('resize', resize);
      reduced.removeEventListener('change', start); controllers.delete(root);
    });
  }
  const init = () => document.querySelectorAll('[data-mh-b2b]').forEach(setup);
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => controllers.forEach((destroy, root) => {
    if (!root.isConnected || event.target.contains(root)) destroy();
  }));
})();
